<template>
  <div class="registers">
    <div class="swiper"><img src="../img/login_bg.png" alt="" /></div>
    <!-- 手机找回 -->
    <div class="loginsss">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="手机找回密码" name="first">
          <div class="ploginss">
            <div class="inputs">
              <el-input
                v-model="phonenumber"
                @input="pnumber"
                maxlength="11"
                placeholder="手机号"
                prefix-icon="el-icon-phone-outline"
              ></el-input>
              <div class="verify">
                <el-input
                  style="margin-top: 0px"
                  @input="pcode"
                  placeholder="请输入验证码"
                  prefix-icon="el-icon-key"
                  v-model="phonecode"
                ></el-input>
                <div
                  @click.stop="sendSmsCode"
                  class="zai-checking"
                  v-if="state === false"
                >
                  获取验证码
                </div>
                <div class="zai-checking zai-time" v-if="state === true">
                  倒计时{{ currentTime }}s
                </div>
              </div>
              <el-input
                placeholder="请输入新密码"
                @input="ppassword"
                show-password
                prefix-icon="el-icon-lock"
                v-model="phonepassword"
              ></el-input>
              <el-input
                placeholder="请确认新密码"
                @input="ppasswords"
                show-password
                prefix-icon="el-icon-lock"
                v-model="phonepasswords"
              ></el-input>
            </div>
            <div @click="sub" style="margin-top: 30px" class="register">
              确认提交
            </div>
          </div>
          <div @click.stop="login" style="text-align: center" class="forget">
            账号登录
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<style lang="scss">
.registers {
  min-width: 1200px;
  position: relative;
  // background: rgba(245, 247, 250, 1);
  .swiper {
    height: 600px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .loginsss {
    width: 358px;
    // height: 400px;
    padding-top: 17px;
    box-sizing: border-box;
    position: absolute;
    right: 20%;
    top: 10%;
    background: #ffffff;
    z-index: 8;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    .find {
      text-align: center;
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(54, 64, 94, 1);
    }
    .el-tabs__nav-scroll {
      display: flex;
      margin-left: 50px;
    }
    .el-tabs__item {
      padding: 0 65px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
    }
    .is-active {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(54, 64, 94, 1);
      background: linear-gradient(
        90deg,
        rgba(49, 114, 255, 1) 0%,
        rgba(24, 144, 255, 1) 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .el-tabs__nav-wrap::after {
      background-color: #ffffff;
    }
    .inputs {
      width: 306px;
      margin: 10px auto 30px auto;
      .el-input__inner {
        border: none;
        border-radius: 0px;
        border-bottom: 1px solid #e6e6e6;
      }
      .el-input {
        margin-top: 30px;
      }
    }
    .forget {
      // width: 306px;
      margin: 18px auto 40px auto;
      text-align: right;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(49, 114, 255, 1);
      cursor: pointer;
    }
    .forget:hover {
      color: red;
      font-weight: 600;
    }
    .guide {
      width: 306px;
      margin: 0px auto 9px auto;

      .el-radio__label {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 153, 153, 1);
      }
    }
    .register {
      width: 306px;
      height: 44px;
      margin: 0 auto;
      background: rgba(15, 119, 191, 1);
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      text-align: center;
      cursor: pointer;
    }
    .zhu {
      cursor: pointer;
      width: 80px;
      height: 44px;
      margin: 19px auto 10px auto;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(25, 141, 255, 1);
      line-height: 44px;
      text-align: center;
    }
    .verify {
      height: 40px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      .el-input__inner {
        width: 60%;
      }
      .zai-checking {
        height: 40px;
        width: 40%;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        color: #0f75bd;
        cursor: pointer;
      }
    }
  }
}
</style>
<script>
import {
  
  changepassword,
  getcodes
 
 
} from "../api.js";
export default {
  name: "Find",
  components: {},
  data() {
    return {
      fetch_static: false,
      activeName: "first",
      fetch_static2: false,
      phonenumber: "",
      phonecode: "",
      phonepassword: "",
      phonepasswords: "",
      input2: "",
      checked: true,
      state: false, //是否开启倒计时
      totalTime: 60, //总时间，单位秒
      recordingTime: 0, //记录时间变量
      currentTime: 0, //显示时间变量
      emailnumber: "", //邮箱号
      ecode: "", //邮箱验证码
      epassword1: "", //新密码
      epassword2: "", //确认新密码
      state2: false, //是否开启倒计时
      totalTime2: 60, //总时间，单位秒
      recordingTime2: 0, //记录时间变量
      currentTime2: 0, //显示时间变量
    };
  },
  methods: {
    handleClick() {
      // console.log(tab, event);
    },
    login() {
      this.$router.push("/Login");
    },

    //获取手机号
    pnumber(e) {
      this.phonenumber = e;
      this.fetch_static = false;
    },
    // 获取验证码
    pcode(e) {
      this.phonecode = e;
      this.fetch_static = false;
    },
    //密码1
    ppassword(e) {
      this.phonepassword = e;
      this.fetch_static = false;
    },
    //密码2
    ppasswords(e) {
      this.phonepasswords = e;
      this.fetch_static = false;
    },

    // 获取邮箱号
    enumber(e) {
      this.emailnumber = e;
    },
    // 获取邮箱验证码
    ecodes(e) {
      this.ecode = e;
    },
    // 获取密码
    ep1(e) {
      this.epassword1 = e;
    },
    // 获取密码2
    ep2(e) {
      this.epassword2 = e;
    },

  

    // 几时
    checkingTime() {
      let that = this;
      //判断是否开启
      if (this.state) {
        //判断显示时间是否已到0，判断记录时间是否已到总时间
        if (this.currentTime > 0 && this.recordingTime <= this.totalTime) {
          //记录时间增加 1
          this.recordingTime = this.recordingTime + 1;
          //显示时间，用总时间 - 记录时间
          this.currentTime = this.totalTime - this.recordingTime;
          //1秒钟后，再次执行本方法
          setTimeout(() => {
            //定时器内，this指向外部，找不到vue的方法，所以，需要用that变量。
            that.checkingTime();
          }, 1000);
        } else {
          //时间已完成，还原相关变量
          this.state = false; //关闭倒计时
          this.recordingTime = 0; //记录时间为0
          this.currentTime = this.totalTime; //显示时间为总时间
        }
      } else {
        //倒计时未开启，初始化默认变量
        this.state = false;
        this.recordingTime = 0;
        this.currentTime = this.totalTime;
      }
    },

    // 短信验证码
    sendSmsCode() {
      let that = this;
      let phone = that.phonenumber;
      let reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
      if (phone.length < 1) {
        that.$message.error("手机号不能为空哦！");
        return;
      } else if (!reg.test(phone)) {
        that.$message.error("手机格式不正确！");
        return;
      }
      let datas = { Type: 1, Phone: phone, Source: "web" };
      getcodes(datas)
        .then((res) => {
          if (res.data.Code == 0) {
            that.$message({
              message: res.data.Data,
              type: "success",
            });
            // 把显示时间设为总时间
            that.currentTime = that.totalTime;
            //开始倒计时
            that.state = true;
            //执行倒计时
            that.checkingTime();
          } else {
            that.$message.error(res.data.Message);
            that.fetch_static = false;
          }
        })
        .catch((error) => {
          console.log(error);
          that.fetch_static = false;
        });
    },

   
    

    // 提交手机找回密码
    sub() {
      let that = this;


    
        let phonenumber = that.phonenumber;
        let phonecode = that.phonecode;
        let phonepassword = that.phonepassword;
        let phonepasswords = that.phonepasswords;
        let reg = 11 && /^((13|14|15|17|18|16)[0-9]{1}\d{8})$/;

        if (!phonenumber) {
          that.$message.error("请填写手机号");
          return;
        }
        if (!reg.test(phonenumber)) {
          that.$message.error("手机格式不正确！");
          return;
        }

        if (phonecode == "") {
          that.$message.error("请填写验证码");
          return;
        }
        if (phonepassword == "") {
          that.$message.error("请填写密码");
          return;
        }
        if (phonepasswords == "") {
          that.$message.error("请确认密码");
          return;
        }

        if (phonepassword != phonepasswords) {
          that.$message.error("二次密码不一致");
          return;
        }
        let datas = {
         
          Phone: phonenumber,

          Code: phonecode,
          Password: phonepassword,
          Password2: phonepasswords,
          Source: "web",
        };
        changepassword(datas)
          .then((res) => {
            if (res.data.Code == 0) {
             
              that.$message({
                message: res.data.Data,
                type: "success",
              });
              setTimeout(() => {
                that.$router.push("/Login");
              }, 800);
            } else {
              that.$message.error(res.data.Message);
            
            }
          })
          .catch((error) => {
            console.log(error);
           
          });
      
    },
  },
};
</script>
